<template>
	<div class="resource-planning-placeholder-icon">
		<button
			v-if="isInteractive"
			v-tooltip="$t('resource_planning_assign_member')"
			:aria-label="$t('resource_planning_assign_member')"
			class="resource-planning-placeholder-icon__button"
			type="button"
		>
			<SuiIcon :name="iconName" />
		</button>
		<div v-else class="resource-planning-placeholder-icon__icon">
			<SuiIcon :name="iconName" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { SuiIcon } from '@developers/scoro-ui';

export type ResourcePlanningPlaceholderIconProps = {
	iconName: string;
	isInteractive?: boolean;
};

defineProps<ResourcePlanningPlaceholderIconProps>();
</script>

<style lang="scss" scoped>
.resource-planning-placeholder-icon {
	padding: 0.25rem;

	&__button,
	&__icon {
		--sui-icon-fill: #{$purple-40};

		display: grid;
		place-items: center;
		width: 3rem;
		height: 3rem;
		border-radius: 3rem;
		border: 1px dashed $purple-40;
		background-color: $neutral-00;
	}

	&__button {
		transition: all 0.3s ease;

		&:hover {
			--sui-icon-fill: #{$purple-50};

			border-color: $purple-50;
			background-color: $purple-10;
		}
	}
}
</style>
